// extracted by mini-css-extract-plugin
export default {"event_info":"styles_event_info__5HLhu","event_recommendation":"styles_event_recommendation__d1R3J"};